import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldInput, FormFieldContainer, CharsCount } from "../../../react-components/modals/modal-form-elements";
import { SetProfileStatePayload, SetProfileStateAction, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { GRAPHQL_TYPE_PERSON } from "@radivision/graphql";

interface MapStateProps {
  superPower: string | null;
  isPerson: boolean;
}
interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapStateProps & MapDispatchProps;

const SUPER_POWER_MAX_LENGTH = 300;

export const Component = (props: Props) => {
  const { setProfileState, superPower, isPerson } = props;

  const [charsCount, setCharsCount] = React.useState<number>(0);
  const textareaId = "profile-super-power-input";

  React.useEffect(() => {
    setCharsCount(superPower ? superPower.length : 0);
  }, [superPower]);

  React.useEffect(
    function resizeTextarea() {
      const textarea = document.getElementById(textareaId);
      if (!textarea) {
        return;
      }
      try {
        textarea.setAttribute(
          "style",
          `min-height:100px;max-height:200px;height:${textarea.scrollHeight}px;overflow-y:auto;`,
        );
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      } catch (error) { }
    },
    [textareaId],
  );

  if (!isPerson) return null;
  return (
    <FormFieldContainer>
      <label htmlFor={textareaId}>
        <span>Super Power:</span>
      </label>
      <FormFieldInput>
        <textarea
          rows={3}
          name="superPower"
          id={textareaId}
          maxLength={SUPER_POWER_MAX_LENGTH}
          placeholder={`What is your superpower in ${SUPER_POWER_MAX_LENGTH} characters or less?`}
          value={superPower}
          onChange={(e) => setProfileState({ superPower: e.target.value })}
        />
        <CharsCount count={charsCount} limit={SUPER_POWER_MAX_LENGTH} />
      </FormFieldInput>
    </FormFieldContainer>
  );
};

export const Container = ({ children }) => {
  return <div className="profile-tagline-input">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  superPower: state.profile.superPower,
  isPerson: state.profile.type === GRAPHQL_TYPE_PERSON,
});

const mapDispatch = {
  setProfileState: setProfileState,
};

export const SuperPower = connect(mapState, mapDispatch)(Component);
